import { authFetch } from "../../HttpClient";

// Appels à l'API Recouvrement (backend-myalfa, /api/recouvrement). Les
// dossiers sont renvoyés dans la forme utilisée par l'écran : intitulé
// comptable sous "nom", clé de rapprochement sous "cle".
const BASE = "https://backend-myalfa.vercel.app/api/recouvrement";

async function appel(url, options) {
  const res = await authFetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options && options.headers) },
  });
  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      // corps non JSON : on garde le statut
    }
    throw new Error(message);
  }
  return res.json();
}

export const dossierDepuisApi = (d) => ({ ...d, nom: d.nomCompta });

export async function chargerRecouvrement() {
  const data = await appel(BASE);
  const dossiers = {};
  (data.dossiers || []).forEach((d) => {
    dossiers[d.cle] = dossierDepuisApi(d);
  });
  return {
    dossiers,
    imports: data.imports || [],
    modeles: data.modeles || {},
  };
}

export const chargerJournal = () => appel(`${BASE}/journal`);

export const importerRecouvrement = (corps) =>
  appel(`${BASE}/import`, { method: "POST", body: JSON.stringify(corps) });

export const modifierDossier = (id, corps) =>
  appel(`${BASE}/${id}`, { method: "PATCH", body: JSON.stringify(corps) }).then(dossierDepuisApi);

export const marquerEnvoyee = (id, corps) =>
  appel(`${BASE}/${id}/envoi`, { method: "POST", body: JSON.stringify(corps) }).then(dossierDepuisApi);

export const cloturerDossier = (id, corps) =>
  appel(`${BASE}/${id}/cloture`, { method: "POST", body: JSON.stringify(corps) }).then(dossierDepuisApi);

export const enregistrerModeles = (modeles) =>
  appel(`${BASE}/modeles`, { method: "PUT", body: JSON.stringify({ modeles }) });

export const envoyerRelance = (id, corps) =>
  appel(`${BASE}/${id}/envoyer`, { method: "POST", body: JSON.stringify(corps) }).then(dossierDepuisApi);
